var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7.0968H7C5.9 7.0968 5 7.9968 5 9.0968V21.0968C5 22.1968 5.9 23.0968 7 23.0968H23C24.1 23.0968 25 22.1968 25 21.0968V9.0968C25 7.9968 24.1 7.0968 23 7.0968ZM22.6 11.3468L16.06 15.4368C15.41 15.8468 14.59 15.8468 13.94 15.4368L7.4 11.3468C7.15 11.1868 7 10.9168 7 10.6268C7 9.9568 7.73 9.5568 8.3 9.9068L15 14.0968L21.7 9.9068C22.27 9.5568 23 9.9568 23 10.6268C23 10.9168 22.85 11.1868 22.6 11.3468Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.89a45e617ec9c4b6f86877a970a8db0f.svg";
export { ForwardRef as ReactComponent };